import { render, staticRenderFns } from "./remove-user.vue?vue&type=template&id=cfbdb09c&scoped=true&"
import script from "./remove-user.vue?vue&type=script&lang=js&"
export * from "./remove-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbdb09c",
  null
  
)

export default component.exports